import React from "react"

export default props => <h2 style={{ color: props.headingColor1 }}>{props.headingText1} <span style={{ color: props.headingColor2 }}>{props.headingText2}</span></h2>
